import {Component, OnInit} from '@angular/core';
import {NgIf} from "@angular/common";
import { environment } from '../../../environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {NgSelectModule} from "@ng-select/ng-select";
import {SucursalDTO} from "../../../dtos/sucursal.dto";
import {ApiService} from "../../services/api.service";
import {JornadaService} from "../../services/jornada.service";
import {EventService} from "../../services/event.service";
import {SucursalService} from "../../services/sucursal.service";
import {JornadaDTO} from "../../../dtos/jornada.dto";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import moment from "moment";
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {ConductorDTO} from "../../../dtos/conductor.dto";
import {HttpErrorResponse} from "@angular/common/http";
import {AppMessage} from "../../app.message";
import {GetListaConductoresResponseDTO} from "../../../dtos/response/getListaConductores.response.dto";
import {PutActualizarHoraJornadaResquestDTO} from "../../../dtos/request/putActualizarHoraJornada.resquest.dto";
import {GeneralResponseDTO} from "../../../dtos/response/general.response.dto";
import {PostCrearJornadaResquestDTO} from "../../../dtos/request/postCrearJornada.resquest.dto";
import {ToastrService} from "ngx-toastr";
import {UserService} from "../../services/user.service";

@Component({
  selector: 'app-modal-crear-jornada',
  standalone: true,
  imports: [
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    NgIf
  ],
  templateUrl: './modal-crear-jornada.component.html',
  styleUrl: './modal-crear-jornada.component.scss'
})
export class ModalCrearJornadaComponent implements OnInit {

  public jornada: JornadaDTO;
  public sucursalSeleccionada: SucursalDTO;
  public listadoSucursalesDisponibles: Array<SucursalDTO> = [];
  public formCrear: FormGroup;
  public listadoConductores: Array<ConductorDTO> = [];
  public creando: boolean = false;

  constructor(private modalRef: BsModalRef, private apiService: ApiService, private jornadaService: JornadaService,
              private eventService: EventService, private sucursalService: SucursalService, 
              private formBuilder: FormBuilder, private toastr: ToastrService, private userService: UserService) {
    this.initForm();
  }

  ngOnInit(): void {
    this.jornada = this.jornadaService.getJornadaSeleccionada();
    this.listadoSucursalesDisponibles =  this.sucursalService.getSucursalesSeleccionadas();
    this.getListaConductores();
  }

  initForm() {
    this.formCrear = this.formBuilder.group({
      sucursal: [null, [Validators.required]],
      conductor: [null, [Validators.required]],
      fechaInicio: [new Date, [Validators.required]],
      fechaTermino: [new Date, [Validators.required]],
      horaInicio: [moment().format('HH:mm'), [Validators.required]],
      horaTermino: [moment().format('HH:mm'), [Validators.required]],
    });
  }

  close() {
    this.modalRef.hide();
  }

  buscarConductorPorIDnombresCompleto(term: string, item: ConductorDTO) {
    term = term.toLocaleLowerCase();
    if(item.visibleId.toLowerCase().indexOf(term) > -1 || item.nombres.toLowerCase().indexOf(term) > -1 || item.apellidoPaterno.toLowerCase().indexOf(term) > -1)
      return true;
    else
      return false;
  }

  getListaConductores() {
    this.apiService.getListaConductores(0, 9999, '', '', 'visibleId', true, true)
      .subscribe(resp => this.getListaConductoresSuccess(resp), (error) => this.getListaConductoresError(error));
  }

  getListaConductoresSuccess(getListaConductoresResponseDTO: GetListaConductoresResponseDTO) {
    console.log('exito get lista conductores', getListaConductoresResponseDTO);
    this.listadoConductores = getListaConductoresResponseDTO.data.list;
    /*
    Lo siguiente es temporal Juan, por una solicitud que realizó Silvana
    lo ideal sería que este dato viniera limpio desde el backend, pero no había tiempo
    */
    this.listadoConductores = this.listadoConductores.filter(
      c => !c.nombres?.toLowerCase().includes('logico')
    );
  }

  getListaConductoresError(error: HttpErrorResponse) {
    console.log('error get lista conductores', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_LISTA_CONDUCTORES_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  tienePermisoCrearJornada(): boolean {
    return this.userService.tienePermiso('JORNADA_CREAR');
  }

  postCrearJornada() {
    if(this.formCrear.invalid) {
      this.formCrear.touched;
      this.formCrear.get('sucursal').markAsTouched();
      this.formCrear.get('conductor').markAsTouched();
      this.toastr.warning('Campos invalidos, por favor revisar', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }

    let postCrearJornadaResquestDTO = new PostCrearJornadaResquestDTO();
    const fechaInicioTmp =  moment(this.formCrear.get('fechaInicio').value).format('YYYY-MM-DD') + ' ' + this.formCrear.get('horaInicio').value;
    const fechaTerminoTmp = moment(this.formCrear.get('fechaTermino').value).format('YYYY-MM-DD') + ' ' + this.formCrear.get('horaTermino').value;
    //postCrearJornadaResquestDTO.fechaInicio = moment.utc(fechaInicioTmp).format();
    //postCrearJornadaResquestDTO.fechaTermino = moment.utc(fechaTerminoTmp).format();
    postCrearJornadaResquestDTO.fechaInicio = moment(fechaInicioTmp, 'YYYY-MM-DD HH:mm').utc().format();
    postCrearJornadaResquestDTO.fechaTermino = moment(fechaTerminoTmp, 'YYYY-MM-DD HH:mm').utc().format();
    postCrearJornadaResquestDTO.uuid = (this.formCrear.get('sucursal').value as SucursalDTO).uuid;
    postCrearJornadaResquestDTO.conductor.uuid = (this.formCrear.get('conductor').value as ConductorDTO).uuid;
    this.creando = true;
    this.apiService.postCrearJornada(postCrearJornadaResquestDTO)
      .subscribe(res => this.postCrearJornadaSuccess(res), error => this.postCrearJornadaError(error));
  }

  postCrearJornadaSuccess(generalResponseDTO: GeneralResponseDTO) {
    console.log('post crear joranda success', generalResponseDTO);
    if(generalResponseDTO.data && generalResponseDTO.data.length > 0)
      this.jornadaService.addListaUuidJornadasRecienCreadas(generalResponseDTO.data[0].uuid);
    //this.alertService.presentAlertaInfo(generalResponseDTO.msg);
    this.toastr.success(generalResponseDTO.msg, 'Éxito', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
    this.eventService.publish('CREAR_JORNADA_SUCCESS');
    this.close();
  }

  postCrearJornadaError(error: HttpErrorResponse) {
    console.log('post crear jornada error', error);
    this.creando = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_EDITAR_HORA_JORNADA_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

}
